'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _electronSelector = require('./electronSelector');

var _electronSelector2 = _interopRequireDefault(_electronSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ElectronLink = function ElectronLink(_ref) {
    var isElectron = _ref.isElectron,
        to = _ref.to,
        children = _ref.children,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, ['isElectron', 'to', 'children', 'className']);

    return isElectron ? _react2.default.createElement(
        'a',
        { href: 'https://app.milanote.com' + to, className: className, target: '_blank' },
        children
    ) : _react2.default.createElement(
        _reactRouter.Link,
        { to: to, className: className },
        children
    );
};

ElectronLink.propTypes = {
    isElectron: _react2.default.PropTypes.bool,
    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node, _react2.default.PropTypes.string]),
    to: _react2.default.PropTypes.string,
    className: _react2.default.PropTypes.string
};

exports.default = (0, _reactRedux.connect)(_electronSelector2.default)(ElectronLink);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/electron/ElectronLink.js
// module id = 427
// module chunks = 0